import React from "react";
import "../../scss/style.css"

export default class SectionHeader extends React.Component {

    render() {
        return <div>
            <hr/>
            <div className={"sectionHeader"}>
                <h6 style={{flex: "5", fontWeight: "bold"}}>{this.props.text}</h6>
                {this.props.canEdit && <span className={"headerIconStyle"} onClick={this.props.onEditClick}><i className={"fa fa-edit"}/></span>}
                {this.props.canAdd && <span className={"headerIconStyle"} onClick={this.props.onAddClick}><i className={"fa fa-plus"}/></span>}
            </div>
            <hr/>
        </div>
    }
}
